import {
    getObjects,
    createObjects,
    updateObjects,
    deleteObjects,
} from './../api/webApplicationApi';
import { v4 as uuidv4 } from 'uuid';
import { Role } from './role';
import { Policy } from './policy';

const objectType = 'system';

export class System {
    private _saveMethod = createObjects;
    private _object: omSystem;
    private _lastError: Error;

    public constructor(systemID: string) {
        this._object = {
            systemID: systemID,
            name: undefined,
            roles: [],
            policies: [],
        };
    }

    public static createNew(): System {
        return new System(uuidv4());
    }

    public static createFromObject(system: omSystem): System {
        const obj = new System(system.systemID);
        obj._object = system;
        obj._saveMethod = updateObjects;
        return obj;
    }

    public async load(): Promise<boolean> {
        const getObject: GetRequest = {
            objectType: objectType,
            keys: [this._object.systemID],
        };
        this._lastError = undefined;
        try {
            const response = await getObjects([getObject]);
            if (
                response &&
                response.length > 0 &&
                response[0].objects &&
                response[0].objects.length == 1
            ) {
                this._saveMethod = updateObjects;
                this._object = response[0].objects[0];
                return true;
            } else {
                this._lastError = new Error('system not found');
                return false;
            }
        } catch (error: any) {
            this._lastError = error;
            return false;
        }
    }

    // public async save(): Promise<boolean> {
    //     const saveObject:CreateUpdateDeleteRequest = {
    //         objectType: objectType,
    //         object: this._object
    //     };
    //     this._lastError = undefined;

    //     if (this._object.name == undefined){
    //         this._lastError = new Error('Name is undefined');
    //         return false;
    //     }
    //     try {
    //         const response = await this._saveMethod([saveObject]);
    //         if (response) {
    //             this._saveMethod = updateObjects;
    //         } else {
    //             this._lastError = new Error('unknow server error');
    //         }
    //         return response;

    //     } catch(error) {
    //         this._lastError = error;
    //         return false;
    //     }
    // }

    // public async delete() {
    //     const deleteObject:CreateUpdateDeleteRequest = {
    //         objectType: objectType,
    //         object: this._object
    //     };
    //     this._lastError = undefined;
    //     try {
    //         const response = await deleteObjects([deleteObject]);
    //         return response;

    //     } catch (error) {
    //         this._lastError = error;
    //         return false;
    //     }
    // }

    public get lastError(): Error {
        return this._lastError;
    }

    public get systemID(): string {
        return this._object.systemID;
    }

    public get name(): string {
        return this._object.name;
    }

    public set name(name: string) {
        this._object.name = name;
    }

    public get roles(): string[] {
        return this._object.roles;
    }

    public addRole(role: Role): void {
        if (this._object.roles.includes(role.roleID)) return;
        this._object.roles.push(role.roleID);
    }

    public deleteRole(role: Role): void {
        const index = this._object.roles.indexOf(role.roleID);
        if (index > -1) {
            this._object.roles.splice(index, 1);
        }
    }

    public get policies(): string[] {
        return this._object.policies;
    }

    public addPolicy(policy: Policy): void {
        if (this._object.policies.includes(policy.policyID)) return;
        this._object.policies.push(policy.policyID);
    }

    public deletePolicy(policy: Policy): void {
        const index = this._object.policies.indexOf(policy.policyID);
        if (index > -1) {
            this._object.policies.splice(index, 1);
        }
    }
}
